var totalSlides = document.querySelectorAll('#sectorsSlider .card').length;
jQuery('#sectorsSlider').slick({
    slidesToShow: (totalSlides >= 5) ? 4 : totalSlides,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    infinite: false,
    prevArrow: jQuery(".sectors-slider-prev"),
    nextArrow: jQuery(".sectors-slider-next"),
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: (totalSlides >= 5) ? 4 : totalSlides,
            }
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: (totalSlides >= 3) ? 3 : totalSlides,
            }
        },
        {
            breakpoint: 678,
            settings: {
                slidesToShow: (totalSlides >= 2) ? 2 : totalSlides,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});